import { Injectable, Renderer2, Inject, RendererFactory2, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
// import { AuthenticationService } from '../../Services/authentication/authentication.service';
// import * as _slaask from '_slaask';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../Services/authentication/authentication.service';
import { LangService } from '../../Services/lang/lang.service';
import { WINDOW } from '../../Services/window/window.service';

declare var _slaask: any;
declare var _slaaskLoader: any;

@Injectable({
  providedIn: 'root',
})
export class SlackService {

  private renderer: Renderer2;
  private widgetURl: string;

  constructor(@Inject(DOCUMENT) private _document, rendererFactory: RendererFactory2,
    @Inject(PLATFORM_ID) private platform: Object,
    private authService: AuthenticationService,
    private langService: LangService,
    @Inject(WINDOW) private window) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  addSlaaskChatFile() {
    // this is not used anymore, here for refference
    const slaaskChat = this.renderer.createElement('script');
    slaaskChat.src = 'https://cdn.slaask.com/chat.js';
    this.renderer.appendChild(this._document.body, slaaskChat);
  }

  addSlaaskChatLoaderFile() {
    // this is not used anymore, here for refference
    const slaaskChat = <HTMLScriptElement> this.renderer.createElement('script');
    if (isPlatformBrowser(this.platform)) {
      slaaskChat.addEventListener('load', this.initSlaask.bind(this));
    }
    slaaskChat.classList.add('slaaskJs');
    slaaskChat.src = 'https://cdn.slaask.com/chat_loader.js';
    this.renderer.appendChild(this._document.body, slaaskChat);
    const style = <HTMLStyleElement> document.createElement("style");
    style.append(`
      @media only screen and (max-height: 680px) {
        body.slaask-fixed{
            position: static!important;
        }
        body.ios #slaask-widget{
            top: auto!important;
            height: calc(100% - env(safe-area-inset-top) )!important;
            bottom: 0!important;
            max-height: calc(100% - env(safe-area-inset-top)) !important;
        }
        body #slaask-widget::before{
            content: '';
        }
      }
    `);
    this.renderer.appendChild(this._document.body, style);
  }

  initSlaask() {
    // console.log('slask loader loaded');
    let _url = 'index';
    if (isPlatformBrowser(this.platform)) {
      _url = this.window.location.href;
    }
    // console.log(_url);
    // console.log(this);
    // this.identifySlaask(_url);
    _slaaskLoader.load(function() {
      // console.log('load || reload slaask widget');
    });
  }

  identify(url) {
    if (!isPlatformBrowser(this.platform)) {
      return;
    }
    const _isCheckout = url.indexOf('checkout') > 0;
    const _isLogged = localStorage.getItem('user');
    // i'll need the checkout object once its there
    try {
      if (_isCheckout && _isLogged && _slaask) {
        const userObj: any = JSON.parse(_isLogged);
        _slaask.identify(userObj.profile.first_name ? userObj.profile.first_name + ' ' + userObj.profile.last_name : userObj.id, {
          user_id: userObj.id,
          email: userObj.email,
          payment_step: this.getCheckoutStep(),
          booking_ref: this.getRefNum(),
          type: 'Booking'
        });
      } else {
        if (_isLogged && _slaask) {
          const userObj: any = JSON.parse(_isLogged);
          _slaask.identify(userObj.profile.first_name + ' ' + userObj.profile.last_name, {
            page: 'index'
          });
        } else {
          if (_slaask) {
            _slaask.identify('web-site-user', {
              page: 'index'
            });
          }
        }
      }
      // this.init(url);
    } catch (error) {
      if (error) {
        console.warn(error);
      }
    }
  }

  // identifySlaask(url) {
  //   if (isPlatformBrowser(this.platform)) {
  //     const _isCheckout = url.indexOf('checkout') > 0;
  //     let userObj: any;
  //     if (this.authService.isLoggedIn()) {
  //       userObj = JSON.parse(localStorage.getItem('user'));
  //     }
  //     this.widgetURl = url;
  //     this.window._slaaskSettings = {
  //       identify: function () {
  //         if (this.authService.isLoggedIn()) return {
  //           id: userObj.id,
  //           user_id: userObj.id,
  //           name: userObj.profile.first_name + ' ' + userObj.profile.last_name,
  //           email: userObj.email,
  //           payment_step: _isCheckout ? this.getCheckoutStep() : '',
  //           booking_ref: _isCheckout ? this.getRefNum() : '',
  //           page: url,
  //           type: _isCheckout ? 'Booking' : 'index',
  //         }; else {
  //           return null;
  //         }
  //       }.bind(this),
  //       key: _isCheckout ? environment.slaask.booking_widget_key : environment.slaask.widget_key,
  //       options: {
  //         debug: false,
  //         display_bubble: true,
  //         language: this.langService.getCurrentLang(),
  //         pulse: true,
  //       },
  //       autoInit: true,
  //       onInit: function (_slaask) {
  //         // console.log('slaask init --------------------- ');
  //       }
  //     }
  //   }
  // }

  identifySlaask(url) {
    if (isPlatformBrowser(this.platform)) {
      const _isCheckout = url.indexOf('checkout') > 0;
      let userObj: any;
      if (this.authService.isLoggedIn()) {
        userObj = JSON.parse(localStorage.getItem('user'));
      }
      this.widgetURl = url;
      this.window._slaaskSettings = {
        identify: function () {
          if (this.authService.isLoggedIn()) return {
            id: this.authService.getCurrentUserObject().id,
            user_id: this.authService.getCurrentUserObject().id,
            name: this.authService.getCurrentUserObject().profile.first_name + ' ' + this.authService.getCurrentUserObject().profile.last_name,
            email: this.authService.getCurrentUserObject().email,
            payment_step:  this.getCheckoutStep(),
            booking_ref: this.getRefNum(),
            page: url,
            type: 'Booking',
          }; else {
            return null;
          }
        }.bind(this),
        key: environment.slaask.booking_widget_key,
        options: {
          debug: false,
          display_bubble: false,
          language: this.langService.getCurrentLang(),
          pulse: false,
        },
        autoInit: true,
        onInit: function (_slaask) {
          // console.log('slaask init --------------------- ');
        }
      }
    }
  }

  init(url) {
    if (!isPlatformBrowser(this.platform)) {
      return;
    }
    try {
      if (_slaask) {
        const _isCheckout = url.indexOf('checkout') > 0;
        const _isLogged = localStorage.getItem('user');
        if (_isCheckout && _isLogged) {
          const userObj: any = JSON.parse(_isLogged);
          _slaask.init(environment.slaask.booking_widget_key, { visitor_token: userObj.id });
        } else {
          _slaask.init(environment.slaask.widget_key);
        }
      }
    } catch (e) {
      console.warn(e);
    }
  }

  updateSlaaskContact() {
    try {
      if (_slaask) {
        _slaask.updateContact();
      }
    } catch (error) {

    }
  }

  destroySlaask() {
    try {
      if (_slaask) {
        _slaask.destroy();
      }
    } catch (error) {

    }
  }

  identifyContact() {
    try {
      if (_slaask) {
        _slaask.identifyContact();
      }
    } catch (error) {

    }
  }

  reload(url) {
    try {
      const _isUrlCheckout = url.indexOf('checkout') > 0;
      const _isCurrentWidgetCheckout = this.widgetURl.indexOf('checkout') > 0;
        if (_isUrlCheckout !==  _isCurrentWidgetCheckout) {
          this.identifySlaask(url);
          _slaaskLoader.reload();
        }
    } catch (error) {
      const _isUrlCheckout = url.indexOf('checkout') > 0;
      const _isCurrentWidgetCheckout = this.widgetURl.indexOf('checkout') > 0;
      if (_isUrlCheckout !==  _isCurrentWidgetCheckout) {
        if (_slaask) {
          _slaask._reloadApp();
        }
      }
    }
  }

  reloadLoader() {
    try {
      if (_slaaskLoader) {
        _slaaskLoader.reload();
      }
    } catch (error) {
      try {
        if (_slaask) {
          _slaask._reloadApp();
        }
      } catch (error) {
      }
    }
  }
  getRefNum() {
    if (isPlatformBrowser(this.platform)) {
      let checkoutObj: any = localStorage.getItem('checkout');
      if (checkoutObj) {
        checkoutObj = checkoutObj ? JSON.parse(checkoutObj) : checkoutObj;
        let checkHash = checkoutObj.checkout_hash ? checkoutObj.checkout_hash : '';
        checkHash = checkHash.slice(-5);
        const checkoutId = checkoutObj.user_trip_checkout_id ? checkoutObj.user_trip_checkout_id : '';
        return checkHash + '-' + checkoutId;
      } else {
        return '';
      }
    }
  }

  getCheckoutStep() {
    if (isPlatformBrowser(this.platform)) {
      const checkoutObj = JSON.parse(localStorage.getItem('checkout'));
      return checkoutObj ? checkoutObj.step : '';
    } else {
      return '';
    }
  }
}
